import { Box, Divider, IconButton, Typography } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { formatDateWithTime } from "../../../../utils/dateUtils";
import { calculateRowTotal, calculateApiItemsTotal } from "../../../orders/utils";
import { OrderSubtype, LogbookOrderItem } from "../../types";
import { ORDER_SUBTYPE_LABELS } from "./LogbookOrderItem";

type OrderDetailPanelProps = {
	order: LogbookOrderItem;
	orderSubtype: OrderSubtype;
};

export const OrderDetailPanel = ({ order, orderSubtype }: OrderDetailPanelProps) => {
	const label = ORDER_SUBTYPE_LABELS[orderSubtype];
	const orderItems = order.order_items ?? [];

	return (
		<Box>
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
				<Typography variant="subtitle1" fontWeight="bold" color="primary.main">{label}</Typography>
				<IconButton
					color="secondary"
					component={Link}
					to={`/orders/${order.id}`}
					target="_blank"
					size="small"
				>
					<OpenInNew />
				</IconButton>
			</Box>
			<Box sx={{px:2, mx: 2}}>

			{orderSubtype === "created_and_paid" ? (
				<>
					<Typography variant="body2" color="text.secondary">Criada: {formatDateWithTime(order.order_date)}</Typography>
					<Typography variant="body2" color="text.secondary">Paga: {formatDateWithTime(order.payment_date)}</Typography>
				</>
			) : (
				<Typography variant="body2" color="text.secondary">
					{formatDateWithTime(orderSubtype === "paid" ? order.payment_date : order.order_date)}
				</Typography>
			)}
			<Divider sx={{ my:4 }} />
			<Typography variant="subtitle2" fontWeight="bold" color="primary.dark" sx={{ mb: 1 }}>Itens</Typography>
			{orderItems.map((item: any, index: number) => {
				const itemTotal = calculateRowTotal(item).toFixed(2);
				return (
					<Box key={index} sx={{ mb: 1.5, pl: 1 }}>
						<Typography variant="body1">{item.service_variant?.service?.name}</Typography>
						<Typography variant="body2" color="text.secondary">
							{item.quantity}x {item.price}€{item.discount ? ` (-${item.discount}%)` : ""} = {itemTotal}€
						</Typography>
					</Box>
				);
			})}
			<Divider sx={{ mt: 2, mb: 1 }} />
			<Typography variant="subtitle1" fontWeight="bold" align="right">
				Total: {calculateApiItemsTotal(orderItems as any).toFixed(2)}€
			</Typography>
			</Box>
		</Box>
	);
};
